import { render, staticRenderFns } from "./UserDashboardPropertiesList.vue?vue&type=template&id=61796ad0"
import script from "./UserDashboardPropertiesList.vue?vue&type=script&lang=js"
export * from "./UserDashboardPropertiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports